import React from 'react';
import { MyMultiSelectOptions } from './MyMultiSelect';
import { Autocomplete, Box, Checkbox, CircularProgress, Collapse, InputLabel, List, ListItemButton, TextField, Typography, FormHelperText, Tooltip } from '@mui/material';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import { DropdownOptions } from '../types';
import { useTranslation } from 'react-i18next';
import Theme from '../../../Themes/main.theme';
import InfoIcon from '@mui/icons-material/Info';

const icon = <CheckBoxOutlineBlankIcon fontSize='small' />;
const checkedIcon = <CheckBoxIcon fontSize='small' />;

const MultiTreeSelect = (props: MyMultiSelectOptions) => {
  const {
    label, customLabel, info, options, groupByElement = 'parent', required, selectedItem, filtersDesign, isLoading, ...rest
  } = props;

  const [value, setValue] = React.useState(props.formik?.initialValues?.[props.name]
    ? props.formik?.initialValues?.[props.name]
    : []);

  // Open state and onClick function for children Dropdown
  const [open, setOpen] = React.useState<string>();
    
  const { t } = useTranslation();

  const handleClick = (group: string) => {
    open === group
      ? setOpen('')
      : setOpen(group);
  };

  const emptyMsg = isLoading ? 
    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
      <CircularProgress size={20} />
    </Box>
    : t('Μη διαθέσιμες επιλογές');
  

  const initialValueInOptions = (options: DropdownOptions[] | any, field: DropdownOptions) =>
    options?.some((x: any) => x.value == field.value);

  const handleChange = (values: any) => {
    if (values.length > 0) {
      setValue(values);
    } else {
      setValue([]);
    }
    props?.formik?.setFieldValue(props.name, values);
    props?.formik?.setTouched({ [props.name]: true });
    selectedItem && selectedItem(values);
  };
  
  React.useEffect(() => {
    if (props?.formik?.initialValues[props.name]
      && props?.formik?.initialValues[props.name].length > 0) {
      const values: DropdownOptions[] =
        props.formik?.initialValues?.[props.name].map((field: DropdownOptions) => {
          if (initialValueInOptions(options, field)) {
            return options?.find((x: any) => x.value == field.value);
          }
        }).filter((x: any) => x);

      handleChange(values);
    }
  }, [props?.formik?.initialValues[props.name]]);

  React.useEffect(() => {
    if (props?.formik?.values[props.name]
      && props?.formik?.values[props.name].length > 0) {
        
      const values: DropdownOptions[] =
        props.formik?.values?.[props.name].map((field: DropdownOptions) => {
          if (initialValueInOptions(options, field)) {
            return options?.find((x: any) => x.value == field.value);
          }
        }).filter((x: any) => x);
      handleChange(values);

    } else if (props?.formik?.initialValues[props.name]
      && props?.formik?.initialValues[props.name].length > 0) {
      
      const values: DropdownOptions[] =
        props.formik?.initialValues?.[props.name].map((field: DropdownOptions) => {
          if (initialValueInOptions(options, field)) {
            return options?.find((x: any) => x.value == field.value);
          }
        }).filter((x: any) => x);

      handleChange(values);
    }
  }, [options]);

  return (
    <>
      {
        customLabel
          ? <Box display='flex' alignItems='center'>
            <InputLabel
              htmlFor={props.name}
              disabled={props.disabled}
              required={required}
              sx={{
                my: customLabel
                  ? 2
                  : 0,
                textAlign: 'left',
                textStyle: 'none',
              }}
            >
              {label}
            </InputLabel>
            {info ? 
              <Tooltip
                PopperProps={{
                  disablePortal: true
                }} title={props?.tooltip}
                placement='right-start'>
                <InfoIcon sx={{color: Theme?.iconColor?.main, ml: 1, fontSize: '17px'}}/>
              </Tooltip>
              : null
            }
          </Box> 
          : null
      }
      <Autocomplete
        sx={{
          ...(filtersDesign && {
            '& .MuiOutlinedInput-root': {
              '& > fieldset': {
                borderRadius: '24px'
              }
            }
          })
        }}
        groupBy={(option: any) => option[groupByElement]}
        fullWidth
        limitTags={2}
        {...rest}
        noOptionsText={emptyMsg}
        isOptionEqualToValue={(option, value) => option.value == value.value}
        value={props?.formik?.values[props.name]
          ? value
          : []}
        disablePortal
        multiple
        options={options || []}
        disableCloseOnSelect
        onChange={(_, values) => handleChange(values)}
        getOptionLabel={(option: any) => option.key}
        renderGroup={(params) => (
          <>
            <List sx={{ width: '100%'}}>
              <ListItemButton onClick={() => handleClick(params.group)}>
                <FormHelperText>
                  <Typography variant='body2'>
                    {params.group}
                  </Typography>
                </FormHelperText>
                <Box ml={1}>
                  {open === params.group
                    ? <ExpandLess htmlColor='#7E7E7E' />
                    : <ExpandMore htmlColor='#7E7E7E' />}
                </Box>
              </ListItemButton>
              <Collapse
                in={open === params.group}
                timeout='auto'
                unmountOnExit>
                <List disablePadding>
                  {params.children}
                </List>
              </Collapse>
            </List>
          </>
        )}
        renderOption={(props, option, { selected }) => (
          <li {...props}>
            <Checkbox
              icon={icon}
              checkedIcon={checkedIcon}
              style={{ marginRight: 8 }}
              checked={selected}
            />
            {option.key}
          </li>
        )}
        renderInput={(params) => (
          <TextField {...params}
            label={customLabel
              ? null
              : label}
          />
        )}
      />
    </>
  );
};

export default MultiTreeSelect;